/**
 * @desc movingAllocationAddPoStock
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.StockOccupyMasterAddRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupy/movingAllocationAddPoStock`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
